// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.register {
  height: 100vh;
  background-color: rgb(193, 190, 255);
  display: flex;
  align-items: center;
  justify-content: center;
}
.register .card {
  width: 50%;
  display: flex;
  flex-direction: row-reverse;
  background-color: white;
  border-radius: 10px;
  min-height: 600px;
  overflow: hidden;
}
.register .card .left {
  flex: 1 1;
  background: linear-gradient(rgba(39, 11, 96, 0.5), rgba(39, 11, 96, 0.5)), url("https://images.pexels.com/photos/4881619/pexels-photo-4881619.jpeg?auto=compress&cs=tinysrgb&w=1600") center;
  background-size: cover;
  padding: 50px;
  display: flex;
  flex-direction: column;
  gap: 30px;
  color: white;
}
.register .card .left h1 {
  font-size: 100px;
  line-height: 100px;
}
.register .card .left span {
  font-size: 14px;
}
.register .card .left button {
  width: 50%;
  padding: 10px;
  border: none;
  background-color: white;
  color: rebeccapurple;
  font-weight: bold;
  cursor: pointer;
}
.register .card .right {
  flex: 1 1;
  padding: 50px;
  display: flex;
  flex-direction: column;
  gap: 50px;
  justify-content: center;
}
.register .card .right h1 {
  color: #555;
}
.register .card .right form {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.register .card .right form input {
  border: none;
  border-bottom: 1px solid lightgray;
  padding: 20px 10px;
}
.register .card .right form button {
  width: 50%;
  padding: 10px;
  border: none;
  background-color: #938eef;
  color: white;
  font-weight: bold;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/pages/register/register.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;AACE;EACE,UAAA;EACA,aAAA;EACA,2BAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AACJ;AACI;EACE,SAAA;EACA,4LAAA;EAGA,sBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;AADN;AAGM;EACE,gBAAA;EACA,kBAAA;AADR;AAOM;EACE,eAAA;AALR;AAQM;EACE,UAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,oBAAA;EACA,iBAAA;EACA,eAAA;AANR;AAUI;EACE,SAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;AARN;AAUM;EACA,WAAA;AARN;AAWM;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AATR;AAWQ;EACA,YAAA;EACA,kCAAA;EACA,kBAAA;AATR;AAYQ;EACE,UAAA;EACA,aAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AAVV","sourcesContent":[".register {\n  height: 100vh;\n  background-color: rgb(193, 190, 255);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  .card {\n    width: 50%;\n    display: flex;\n    flex-direction: row-reverse;\n    background-color: white;\n    border-radius: 10px;\n    min-height: 600px;\n    overflow: hidden;\n\n    .left {\n      flex: 1;\n      background: linear-gradient(rgba(39, 11, 96, 0.5), rgba(39, 11, 96, 0.5)),\n        url(\"https://images.pexels.com/photos/4881619/pexels-photo-4881619.jpeg?auto=compress&cs=tinysrgb&w=1600\")\n          center;\n      background-size: cover;\n      padding: 50px;\n      display: flex;\n      flex-direction: column;\n      gap: 30px;\n      color: white;\n\n      h1 {\n        font-size: 100px;\n        line-height: 100px;\n      }\n      \n      p {\n      }\n\n      span {\n        font-size: 14px;\n      }\n      \n      button {\n        width: 50%;\n        padding: 10px;\n        border: none;\n        background-color: white;\n        color: rebeccapurple;\n        font-weight: bold;\n        cursor: pointer;\n      }\n    }\n\n    .right {\n      flex: 1;\n      padding: 50px;\n      display: flex;\n      flex-direction: column;\n      gap: 50px;\n      justify-content: center;\n\n      h1 {\n      color: #555;\n      }\n      \n      form {\n        display: flex;\n        flex-direction: column;\n        gap: 30px;\n        \n        input {\n        border: none;\n        border-bottom: 1px solid lightgray;\n        padding: 20px 10px;\n        }\n        \n        button {\n          width: 50%;\n          padding: 10px;\n          border: none;\n          background-color: #938eef;\n          color: white;\n          font-weight: bold;\n          cursor: pointer;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
